export enum SubscriptionLevel {
  EntitlementEnterprise = "entitlement_enterprise",
  EntitlementProfessional = "entitlement_professional",
  EntitlementStarter = "entitlement_starter",
}
